
<template>
  <div data-switcher-x>
    <label
      v-if="type !== 'group'"
      class="c-switcher"
      :class="{ 'c-switcher_checkbox': type === 'checkbox' }"
      @click="toggle"
      @mousedown="mousedown"
    >
      <div v-if="!type" class="c-switcher-indicator" :class="{ 'c-switcher-indicator_active': localValue }">
        <div class="c-switcher-indicator-circle"></div>
      </div>

      <input
        v-if="type === 'checkbox'"
        v-model="localValue"
        type="checkbox"
        class="c-switcher-input"
        :disabled="disabled"
      />

      <input
        v-if="type === 'radio' || type === 'radio-colours'"
        
        :name="nameRadioGroup"
        type="radio"
        class="c-switcher-input-radio"
        :disabled="disabled"
        :checked="localValue"
        @change="localValue = !localValue"
      />

      <div v-if="type === 'checkbox'" class="c-switcher-checkbox">
        <svg
          class="c-switcher-checkbox-icon c-switcher-checkbox-icon_check"
          width="11"
          height="8"
          viewBox="0 0 11 8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z"
          />
          <path
            d="M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z"
          />
        </svg>
      </div>

      <div v-if="type === 'radio' || type === 'radio-colours'" class="c-switcher-radio">
        <div class="c-switcher-radio-circle"></div>
      </div>

      <div v-if="image" class="c-switcher-image" :style="{ 'background-image': `url(${image})` }"></div>

      <div
        v-if="type !== 'radio-colours'"
        class="c-switcher-label"
        :class="{
          'c-switcher-label_nowrap': nowrap,
          'c-switcher-label_active': localValue,
          'c-switcher-label_label': label.color && label.color === 'label',
        }"
        v-html="label.text ? label.text : label"
      ></div>

      <div
        v-if="type === 'radio-colours' && colours"
        class="c-switcher-label"
        :class="{
          'c-switcher-label_active': localValue,
        }"
      >
        <div class="c-switcher-label-colours">
          <div
            v-for="color in colours"
            :key="color"
            :style="{ background: color }"
            class="c-switcher-label-colours-item"
          ></div>
        </div>
      </div>

      <div v-if="labelFullName" class="c-switcher-label-fullname">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: labelFullName,
            placement: 'bottom',
          }"
          size="iconic"
          icon="info"
        />
      </div>
    </label>

    <div
      v-if="type === 'group'"
      class="c-switcher-group"
      :class="{
        disabled: disabled,
      }"
    >
      <div
        v-for="item in items"
        :key="item.value"
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: item.tooltip,
          placement: 'top',
        }"
        class="c-switcher-group-item"
        :class="{
          'c-switcher-group-item_active': localValue === item.value,
          'c-switcher-group-item_iconic': item.icon,
          'c-switcher-group-item_bg_success': item.bg === 'success',
          'c-switcher-group-item_bg_error': item.bg === 'error',
          'c-switcher-group-item_border_color_green': item.borderColor === 'green',
        }"
        @click="!disabled && (localValue = item.value)"
      >
        <div
            v-if="item.icon && item.icon === 'ruble'"
            width="9"
            height="11"
            style="text-align: center;width: 2.5rem;"
        >
          ฿
        </div>

        <svg
          v-if="item.icon && item.icon === 'male'"
          :class="{
            'c-switcher-group-item_active_male': localValue === item.value,
          }"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 6L14 1M14 1V5M14 1H10M10 9.5C10 11.9853 7.98528 14 5.5 14C3.01472 14 1 11.9853 1 9.5C1 7.01472 3.01472 5 5.5 5C7.98528 5 10 7.01472 10 9.5Z"
            fill="none"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'female'"
          :class="{
            'c-switcher-group-item_active_female': localValue === item.value,
          }"
          fill="none"
          width="11"
          height="17"
          viewBox="0 0 11 17"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.53564 16V11M8 14H3M10 5.5C10 7.98528 7.98528 10 5.5 10C3.01472 10 1 7.98528 1 5.5C1 3.01472 3.01472 1 5.5 1C7.98528 1 10 3.01472 10 5.5Z"
            fill="none"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'percent'"
          width="12"
          height="13"
          viewBox="0 0 12 13"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.625 5.75C3.15625 5.75 2.71094 5.63281 2.3125 5.39844C1.89062 5.16406 1.58594 4.85938 1.35156 4.4375C1.11719 4.03906 1 3.59375 1 3.125C1 2.65625 1.11719 2.23438 1.35156 1.8125C1.58594 1.41406 1.89062 1.08594 2.3125 0.851562C2.71094 0.617188 3.15625 0.5 3.625 0.5C4.09375 0.5 4.51562 0.617188 4.9375 0.851562C5.33594 1.08594 5.66406 1.41406 5.89844 1.8125C6.13281 2.23438 6.25 2.65625 6.25 3.125C6.25 3.59375 6.13281 4.03906 5.89844 4.4375C5.66406 4.85938 5.33594 5.16406 4.9375 5.39844C4.51562 5.63281 4.09375 5.75 3.625 5.75ZM3.625 2C3.29688 2 3.03906 2.11719 2.82812 2.32812C2.59375 2.5625 2.5 2.82031 2.5 3.125C2.5 3.45312 2.59375 3.71094 2.82812 3.92188C3.03906 4.15625 3.29688 4.25 3.625 4.25C3.92969 4.25 4.1875 4.15625 4.42188 3.92188C4.63281 3.71094 4.75 3.45312 4.75 3.125C4.75 2.82031 4.63281 2.5625 4.42188 2.32812C4.1875 2.11719 3.92969 2 3.625 2ZM8.875 7.25C9.34375 7.25 9.76562 7.36719 10.1875 7.60156C10.5859 7.83594 10.9141 8.16406 11.1484 8.5625C11.3828 8.98438 11.5 9.40625 11.5 9.875C11.5 10.3438 11.3828 10.7891 11.1484 11.1875C10.9141 11.6094 10.5859 11.9141 10.1875 12.1484C9.76562 12.3828 9.34375 12.5 8.875 12.5C8.40625 12.5 7.96094 12.3828 7.5625 12.1484C7.14062 11.9141 6.83594 11.6094 6.60156 11.1875C6.36719 10.7891 6.25 10.3438 6.25 9.875C6.25 9.40625 6.36719 8.98438 6.60156 8.5625C6.83594 8.16406 7.14062 7.83594 7.5625 7.60156C7.96094 7.36719 8.40625 7.25 8.875 7.25ZM8.875 11C9.17969 11 9.4375 10.9062 9.67188 10.6719C9.88281 10.4609 10 10.2031 10 9.875C10 9.57031 9.88281 9.3125 9.67188 9.07812C9.4375 8.86719 9.17969 8.75 8.875 8.75C8.54688 8.75 8.28906 8.86719 8.07812 9.07812C7.84375 9.3125 7.75 9.57031 7.75 9.875C7.75 10.2031 7.84375 10.4609 8.07812 10.6719C8.28906 10.9062 8.54688 11 8.875 11ZM10.1875 0.5C10 0.5 9.83594 0.59375 9.74219 0.734375L1.11719 11.6094C0.976562 11.7969 0.953125 12.0078 1.07031 12.1953C1.16406 12.4062 1.32812 12.5 1.5625 12.5H2.35938C2.54688 12.5 2.6875 12.4297 2.80469 12.2656L11.4062 1.39062C11.5234 1.20312 11.5234 1.01562 11.4297 0.804688C11.3125 0.617188 11.1484 0.5 10.9375 0.5H10.1875Z"
          />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'operator'"
          :class="{
            'c-switcher-group-item_active_operator': localValue === item.value,
          }"
          fill="#FFFFFF"
          width="17"
          height="15"
          viewBox="0 0 17 15"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 6C3 4.67392 3.57946 3.40215 4.61091 2.46447C5.64236 1.52678 7.04131 1 8.5 1C9.95869 1 11.3576 1.52678 12.3891 2.46447C13.4205 3.40215 14 4.67392 14 6"
            stroke="#0066FF"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M3 10C3 11.0609 3.52678 12.0783 4.46447 12.8284C5.40215 13.5786 6.67392 14 8 14"
            stroke="#0066FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect x="13" y="6" width="3" height="4" rx="1" stroke="#0066FF" fill="#ffffff" stroke-width="2" />
          <rect x="1" y="6" width="3" height="4" rx="1" stroke="#0066FF" fill="#ffffff" stroke-width="2" />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'administrator'"
          :class="{
            'c-switcher-group-item_active_administrator': localValue === item.value,
          }"
          width="18"
          height="15"
          fill="none"
          viewBox="0 0 18 15"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0088 3.00342C10.0088 3.5557 9.56107 4.00342 9.00879 4.00342V6.00342C10.6656 6.00342 12.0088 4.66027 12.0088 3.00342H10.0088ZM9.00879 4.00342C8.4565 4.00342 8.00879 3.5557 8.00879 3.00342H6.00879C6.00879 4.66027 7.35193 6.00342 9.00879 6.00342V4.00342ZM8.00879 3.00342C8.00879 2.45113 8.4565 2.00342 9.00879 2.00342V0.00341797C7.35194 0.00341797 6.00879 1.34656 6.00879 3.00342H8.00879ZM9.00879 2.00342C9.56107 2.00342 10.0088 2.45113 10.0088 3.00342H12.0088C12.0088 1.34656 10.6656 0.00341797 9.00879 0.00341797V2.00342Z"
            fill="#0066FF"
          />
          <path
            d="M12 10.8469C12 11.3992 12.4477 11.8469 13 11.8469C13.5523 11.8469 14 11.3992 14 10.8469H12ZM10.3274 7.98975V6.98975V7.98975ZM7.67255 7.98975V6.98975V7.98975ZM4 10.8469C4 11.3992 4.44772 11.8469 5 11.8469C5.55228 11.8469 6 11.3992 6 10.8469H4ZM14 10.8469C14 9.84466 13.6282 8.87115 12.9475 8.14346L11.4869 9.5097C11.8086 9.85365 12 10.3336 12 10.8469H14ZM12.9475 8.14346C12.2647 7.41351 11.3238 6.98975 10.3274 6.98975V8.98975C10.7487 8.98975 11.1673 9.16802 11.4869 9.5097L12.9475 8.14346ZM10.3274 6.98975H7.67255V8.98975H10.3274V6.98975ZM7.67255 6.98975C6.67616 6.98975 5.73526 7.41351 5.05247 8.14346L6.51308 9.5097C6.83269 9.16802 7.25133 8.98975 7.67255 8.98975V6.98975ZM5.05247 8.14346C4.37179 8.87115 4 9.84466 4 10.8469H6C6 10.3336 6.19135 9.85365 6.51308 9.5097L5.05247 8.14346Z"
            fill="#0066FF"
          />
          <path
            fill="#ffffff"
            d="M1 14V13C1 11.8954 1.89543 11 3 11H15C16.1046 11 17 11.8954 17 13V14"
            stroke="#0066FF"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'sushi'"
          :class="{
            'c-switcher-group-item_active_sushi': localValue === item.value,
          }"
          fill="none"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="1" y="1" width="6" height="6" rx="2" stroke="#0066FF" fill="#ffffff" stroke-width="2" />
          <rect x="7" y="1" width="6" height="6" rx="2" stroke="#0066FF" fill="#ffffff" stroke-width="2" />
          <rect x="1" y="7" width="6" height="6" rx="2" stroke="#0066FF" fill="#ffffff" stroke-width="2" />
          <rect x="7" y="7" width="6" height="6" rx="2" stroke="#0066FF" fill="#ffffff" stroke-width="2" />
          <rect x="3" y="3" width="2" height="2" rx="1" stroke="#0066FF" fill="#ffffff" />
          <rect x="3" y="9" width="2" height="2" rx="1" stroke="#0066FF" fill="#ffffff" />
          <rect x="9" y="3" width="2" height="2" rx="1" stroke="#0066FF" fill="#ffffff" />
          <rect x="9" y="9" width="2" height="2" rx="1" stroke="#0066FF" fill="#ffffff" />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'pizza'"
          :class="{
            'c-switcher-group-item_active_pizza': localValue === item.value,
          }"
          fill="none"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 8C15 9.61949 14.4385 11.1889 13.4111 12.4408C12.3837 13.6926 10.954 14.5496 9.36563 14.8655C7.77726 15.1814 6.12848 14.9369 4.70022 14.1734C3.27196 13.41 2.15259 12.175 1.53284 10.6788C0.913093 9.18257 0.831305 7.51776 1.30142 5.96801C1.77153 4.41826 2.76445 3.07945 4.11101 2.17971C5.45756 1.27997 7.07443 0.87497 8.68612 1.03371C10.2978 1.19244 11.8046 1.9051 12.9497 3.05025L8 8H15Z"
            fill="#ffffff"
            stroke="#0066FF"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <rect x="4" y="9" width="2" height="2" rx="1" fill="#0066FF" />
          <rect x="7" y="3" width="2" height="2" rx="1" fill="#0066FF" />
          <rect x="7" y="11" width="2" height="2" rx="1" fill="#0066FF" />
          <rect x="3" y="5" width="3" height="3" rx="1.5" fill="#0066FF" />
          <rect x="9" y="8" width="3" height="3" rx="1.5" fill="#0066FF" />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'hot'"
          :class="{
            'c-switcher-group-item_active_hot': localValue === item.value,
          }"
          fill="none"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#ffffff"
            d="M15 13C15 12.2121 14.8448 11.4319 14.5433 10.7039C14.2417 9.97595 13.7998 9.31451 13.2426 8.75736C12.6855 8.20021 12.0241 7.75825 11.2961 7.45672C10.5681 7.15519 9.78793 7 9 7C8.21207 7 7.43185 7.15519 6.7039 7.45672C5.97595 7.75825 5.31451 8.20021 4.75736 8.75736C4.20021 9.31451 3.75825 9.97595 3.45672 10.7039C3.15519 11.4319 3 12.2121 3 13L9 13H15Z"
            stroke="#0066FF"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path d="M1 13H17" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M3 5V2" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M15 5V2" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M7 3V1" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M11 3V1" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M9 7V6" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'driver'"
          :class="{
            'c-switcher-group-item_active_driver': localValue === item.value,
          }"
          fill="none"
          width="16"
          height="14"
          viewBox="0 0 16 14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3 11V13" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M13 11V13" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M6 8H10" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M1 8H3" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path d="M13 8H15" stroke="#0066FF" stroke-width="2" stroke-linecap="round" />
          <path
            d="M3 5L2.01121 4.85066L1.83762 6H3V5ZM13 5V6H14.1624L13.9888 4.85066L13 5ZM5.35013 1.00001L5.34688 2.00001H5.35013V1.00001ZM4.17553 1.31228L3.66421 0.45289L4.17553 1.31228ZM3.43175 2.14142L2.50926 1.7554C2.47752 1.83126 2.45525 1.91076 2.44297 1.99208L3.43175 2.14142ZM10.6499 1.00001V2.00002L10.6531 2.00001L10.6499 1.00001ZM11.8245 1.31228L12.3358 0.45289L11.8245 1.31228ZM12.5682 2.14142L13.557 1.99208C13.5448 1.91076 13.5225 1.83126 13.4907 1.7554L12.5682 2.14142ZM3 6H13V4H3V6ZM5.35339 1.80602e-05C4.76156 -0.00190961 4.17165 0.150969 3.66421 0.45289L4.68685 2.17167C4.86685 2.06458 5.09792 1.9992 5.34688 2.00001L5.35339 1.80602e-05ZM3.66421 0.45289C3.15599 0.755273 2.74061 1.20253 2.50926 1.7554L4.35424 2.52744C4.40315 2.41056 4.50763 2.2783 4.68685 2.17167L3.66421 0.45289ZM2.44297 1.99208L2.01121 4.85066L3.98879 5.14934L4.42054 2.29076L2.44297 1.99208ZM10.6531 2.00001C10.9021 1.9992 11.1332 2.06458 11.3131 2.17167L12.3358 0.45289C11.8283 0.150969 11.2384 -0.00190961 10.6466 1.80602e-05L10.6531 2.00001ZM11.3131 2.17167C11.4924 2.2783 11.5968 2.41056 11.6458 2.52744L13.4907 1.7554C13.2594 1.20253 12.844 0.755272 12.3358 0.45289L11.3131 2.17167ZM11.5795 2.29076L12.0112 5.14934L13.9888 4.85066L13.557 1.99208L11.5795 2.29076ZM5.35013 2.00001H10.6499V1.27554e-05H5.35013V2.00001Z"
            fill="#0066FF"
          />
          <rect x="1" y="5" width="14" height="6" rx="2" stroke="#0066FF" stroke-width="2" />
        </svg>

        <div class="c-switcher-group-item-label">
          <slot
            name="label"
            :item="item"
          >
            <div v-html="item.label"></div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";

export default {
  name: "c-switcher",

  components: { CButton },

  props: [
    "label",
    "labelFullName",
    "value",
    "type",
    "items",
    "nowrap",
    "model2",
    "image",
    "nameRadioGroup",
    "colours",
    "disabled",
  ],

  data() {
    return {
      localValue: this.value ? this.value : false,
    };
  },

  watch: {
    localValue(value) {
      this.$emit("input", value);
    },
    value(value) {
      this.localValue = value;
    },
  },

  methods: {
    toggle(e) {
      if (e.target.closest(".c-button")) return;

      if (!this.type) {
        this.localValue = !this.localValue;
      }
    },

    mousedown(e) {
      this.$emit("mousedown", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-switcher {
  display: flex;
  align-items: center;
  cursor: pointer;

  &-indicator {
    width: 38px;
    height: 20px;
    background: $line;
    border-radius: 10px;
    transition: 0.2s;
    align-items: center;
    display: flex;
    position: relative;
    flex-shrink: 0;

    &-circle {
      width: 16px;
      height: 16px;
      background: white;
      border-radius: 50%;
      transition: 0.2s;
      left: 2px;
      position: absolute;
    }

    &_active {
      background: $link;
      justify-content: flex-end;

      .c-switcher-indicator-circle {
        left: 20px;
      }
    }
  }

  &-label {
    font-size: 13px;
    line-height: 14px;
    margin-left: 13px;
    transition: 0.2s;

    &_nowrap {
      white-space: nowrap;
    }

    &_label {
      color: $color-label;
    }

    &-colours {
      display: flex;
      width: 100px;
      height: 20px;

      &-item {
        width: 20px;
        height: 20px;
      }
    }

    &-fullname {
      margin-left: 10px;
    }
  }

  &-input {
    display: none;

    &:checked + .c-switcher-checkbox {
      background: $color-primary;
      border-color: $color-primary;

      & + .c-switcher-label {
        // color: black;
      }
    }

    &-radio {
      display: none;

      &:checked + .c-switcher-radio {
        background: #0066ff;
        border: 1px solid #0066ff;
        
      }
      &:checked + .c-switcher-radio > .c-switcher-radio-circle {
        display: block;
      }
    }
  }

  &-image {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    margin-left: 12px;
    border-radius: 50%;
    background: {
      size: cover;
      position: center;
    }
  }

  &-checkbox {
    width: 18px;
    height: 18px;
    transition: 0.2s;
    border-radius: 3px;
    border: 1px solid #bfc9e0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;

    &-icon {
      fill: white;

      &_check {
        width: 11px;
        height: 8px;
        position: absolute;
        top: 4px;
        left: 3px;
      }
    }
  }

  &-group {
    display: inline-flex;
    border-radius: 15px;
    border: 1px solid $color-button-border;
    box-sizing: border-box;

    &.disabled {
      pointer-events: none;
      opacity: 0.6;
    }

    &-item {
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid $color-button-border;
      transition: 0.2s;
      cursor: pointer;
      padding: 0 20px;

      &_iconic {
        width: 35px;
        padding: 0;
      }

      &-label {
        font: {
          size: 12px;
          weight: 500;
        }
        max-width: 100%;
        color: $color-label;
        transition: 0.2s;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      svg {
        fill: $color-primary;
        transition: 0.2s;
      }

      &:first-child {
        border-left: none;
        border-radius: 15px 0 0 15px;
      }

      &:last-child {
        border-radius: 0 15px 15px 0;
      }

      &_active {
        background: $color-bg;

        &.c-switcher-group-item_bg_success {
          background: $color-success-light;
        }

        &.c-switcher-group-item_bg_error {
          background: $color-error-light;
        }

        &.c-switcher-group-item_border_color_green {
          &::after {
            border-color: $color-success!important;
          }
        }

        svg {
          fill: $color-font;
        }

        .c-switcher-group-item-label {
          color: $color-font;
        }

        &_operator {
          & path {
            stroke: $color-font;
          }

          & rect {
            stroke: $color-font;
          }
        }

        &_administrator {
          & path:not(:first-child) {
            stroke: $color-font;
          }

          & path:first-child {
            fill: $color-font;
          }

          & rect {
            stroke: $color-font;
          }
        }

        &_sushi {
          & path {
            stroke: $color-font;
          }

          & rect {
            stroke: $color-font;
          }
        }

        &_pizza {
          & path {
            stroke: $color-font;
          }

          & rect {
            stroke: $color-font;
          }
        }

        &_hot {
          & path {
            stroke: $color-font;
          }

          & rect {
            stroke: $color-font;
          }
        }

        &_driver {
          & path {
            stroke: $color-font;
          }

          & rect {
            stroke: $color-font;
          }
        }

        &_male,
        &_female {
          fill: none;
          & path {
            stroke: $color-font;
          }
        }
      }
    }
  }

  &-radio {
    position: relative;
    width: 18px;
    height: 18px;
    transition: 0.2s;
    border-radius: 50%;
    border: 1px solid #bfc9e0;
    box-sizing: border-box;
    flex-shrink: 0;

    &-circle {
      position: absolute;
      display: none;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background: #ffffff;
      width: 6px;
      height: 6px;
    }
  }
}
.reference-reasons-for-fine-and-bonuses__subheader {
  .h-switcher {
    margin-right: 30px;
    .c-switcher-group {
      @include mobileAndTablet {
        width: 100% !important;
      }
    }
  }
}

</style>
